import { useTranslation } from "react-i18next";
import { FtblMatchInfo } from "../../../../pages/project/components/ftbl/ftblMatchInfo.types";
import { Flag } from "./Flag";
import { formatDate } from "../../../../../_ftbl/main/helpers/dateFormatting";
import { FtblCoverImageDates, FtblCoverImageName, FtblCoverImageNames, FtblCoverImageNoScoreInfo } from "./styles";

export const TeamWithoutScore = ({ matchInfo }: { matchInfo: FtblMatchInfo }) => {
    const { i18n: { language } } = useTranslation();

    return <>
        <Flag countryId={matchInfo.HomeTeamCountryId} />
        <FtblCoverImageNoScoreInfo>
            <FtblCoverImageNames>
                <FtblCoverImageName>{matchInfo.HomeTeamName}</FtblCoverImageName>
                <FtblCoverImageName>{matchInfo.GuestTeamName}</FtblCoverImageName>
            </FtblCoverImageNames>
            <FtblCoverImageDates>
                <div>{formatDate(matchInfo.Date || '', language, 'day')}</div>
                <div>{formatDate(matchInfo.Date || '', language, 'time')}</div>
            </FtblCoverImageDates>
        </FtblCoverImageNoScoreInfo>
        <Flag countryId={matchInfo.GuestTeamCountryId} />
    </>
}
import { useTranslation } from "react-i18next";
import { FtblMatchInfo } from "../../../../pages/project/components/ftbl/ftblMatchInfo.types";
import { Flag } from "./Flag";
import { formatDate } from "../../../../../_ftbl/main/helpers/dateFormatting";
import { FtblCoverImageDates, FtblCoverImageName, FtblCoverImageNames, FtblCoverImageNoScoreInfo } from "./styles";

export const TeamWithoutScore = ({ matchInfo }: { matchInfo: FtblMatchInfo }) => {
    const { i18n: { language } } = useTranslation();

    return <>
        <Flag countryId={matchInfo.HomeTeamCountryId} />
        <FtblCoverImageNoScoreInfo>
            <FtblCoverImageNames>
                <FtblCoverImageName>{matchInfo.HomeTeamName}</FtblCoverImageName>
                <FtblCoverImageName>{matchInfo.GuestTeamName}</FtblCoverImageName>
            </FtblCoverImageNames>
            <FtblCoverImageDates>
                <div>{formatDate(matchInfo.Date || '', language, 'day')}</div>
                <div>{formatDate(matchInfo.Date || '', language, 'time')}</div>
            </FtblCoverImageDates>
        </FtblCoverImageNoScoreInfo>
        <Flag countryId={matchInfo.GuestTeamCountryId} />
    </>
}
